import { http } from "../http";
//
export const getApplications = async (userId) => {
  try {
    const response = await http.get(`/applications/get_all/${userId}`);
    const applications = response.data;
    return applications.map((application) => {
      // Grid requires a unique id for each row, sometimes the id is undefined from API.
      if (!application.id) {
        application.id =
          application.application_id + application.education_award_id;
      }
      return application;
    });
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getApplicationsMenu = async () => {
  try {
    const response = await http.get(`/api/applications`);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const getEducation = async (userId) => {
  try {
    const url = `/api/education/verified_degrees?user_id=${userId}`;
    const response = await http.get(url);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const getEmployment = async (userId) => {
  try {
    const url = `/user/get_user_employment/${userId}`;
    const response = await http.get(url);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const getInstructorApplication = async (id, action) => {
  try {
    const url = `/api/ohioapproved/instructor_app/${id}`;
    const response = await http.get(url);
    return response.data;
  } catch (ex) {
    if (ex.message === "Request failed with status code 404") {
      console.log("No Instructor app for this user");
    } else {
      console.log(ex);
      throw ex;
    }
  }
};

export const saveInstructorApplication = async (id, data) => {
  try {
    const url = `/api/ohioapproved/instructor_app/${id}`;
    const response = await http.put(url, data);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};
export const submitInstructorApplication = async (data) => {
  try {
    const url = `/api/ohioapproved/instructor_levels`;
    const response = await http.put(url, data);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const saveNewInstructorApplication = async (data) => {
  try {
    const url = `/api/ohioapproved/instructor_app`;
    const response = await http.post(url, data);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const getInstructorLists = async () => {
  try {
    const url = `/api/ohioapproved/lists`;
    const response = await http.get(url);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getAllInstructorApplications = async (userId) => {
  try {
    const url = `/applications/get_all_instructor_applications/${userId}`;
    const response = await http.get(url);
    return response.data;
  } catch (ex) {
    console.log(ex);
    throw ex;
  }
};

export const getAllTrainingApps = async ({
  page,
  pageSize,
  sortBy,
  sortDesc,
  columnFilters,
}) => {
  try {
    const response = await http.get("/api/training", {
      params: {
        page,
        pageSize,
        sortBy,
        sortDesc,
        columnFilters: JSON.stringify(columnFilters),
      },
    });
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};

export const getTrainingAppsReport = async (data, doc_name = "") => {
  try {
    const response = await http.post(
      "/reports/training_apps_report?doc_name=" + doc_name,
      { data }
    );
    return response;
  } catch (ex) {
    console.log(ex);
  }
};

export const getAppsReport = async (data, doc_name = "") => {
  const slimData = data.map(row => ({
    id: row.id,
    user_id: row.user_id,
    status: row.status,
    date_submitted: row.date_submitted,
    date_approved: row.date_approved,
    date_expired: row.date_expired,
    date_updated: row.date_updated,
    name: row.name,
    first_name: row.first_name,
    last_name: row.last_name,
    opin: row.opin
  }));

  try {
    const response = await http.post(
        "/reports/apps_queue_report?doc_name=" + doc_name,
        { slimData }
    );
    return response;
  } catch (ex) {
    console.log(ex);
  }
};
